/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description payer constants
 */

import _ from 'lodash';
import { ELIGIBILITY_PAYER_STATUS } from '../eligibility';

const TRANSACTION_TYPE_CODES: Record<'eligibility' | 'claimStatus' | 'memberId', Payers.ITransactionType> = {
	eligibility: '270',
	claimStatus: '276',
	memberId: 'EZMID',
};

const TRANSACTION_COLORS = {
	eligibility: '#EB2F96',
	claimChecks: '#B37FEB',
};

const PAYER_FILTER_FIELDS = {
	name: {
		key: 'name',
		label: 'Payer Name',
		placeHolder: 'Search by Payer Name',
	},
	status: {
		key: 'status',
		label: 'Payer Status',
		placeHolder: 'Select the Statuses',
		selectAllLabel: 'All Statuses',
	},
	transactions: {
		key: 'transactions',
		label: 'Transactions',
		placeHolder: 'Select the Types',
		selectAllLabel: 'All Types',
	},
	enrollmentRequired: {
		key: 'enrollmentRequired',
		label: 'Enrollment Required',
	},
	filterButtons: { reset: 'Clear', submit: 'Search', apply: 'Apply' },
};

const PAYER_STATUS_OPTIONS = _.map(ELIGIBILITY_PAYER_STATUS, (meta, code) => ({
	value: _.toNumber(code) as Payers.IPayerStatus,
	label: meta.label,
	color: meta.color,
}));

const PAYER_TRANSACTION_OPTIONS = [
	{
		value: TRANSACTION_TYPE_CODES.eligibility,
		label: 'Eligibility',
		color: TRANSACTION_COLORS.eligibility,
	},
	{
		value: TRANSACTION_TYPE_CODES.claimStatus,
		label: 'Claim Checks',
		color: TRANSACTION_COLORS.claimChecks,
	},
];

const DISABLE_PAYER_FIELDS = {
	deactivate: {
		key: 'deactivate',
		label: 'Deactivate Payer',
		danger: true,
	},
};

const PAYER_ENROLLMENT_OPTIONS = [
	{
		value: true,
		label: 'Yes',
	},
	{
		value: false,
		label: 'No',
	},
];

const TRANSACTION_TYPES = _.keyBy(PAYER_TRANSACTION_OPTIONS, ({ value }) => value);

const PAYER_TABS = {
	providers: {
		key: 'providers',
		label: 'Providers',
	},
	contact: {
		key: 'contact',
		label: 'Contact Info',
	},
	maintenance: {
		key: 'maintenance',
		label: 'Maintenance Time',
	},
};

export {
	TRANSACTION_TYPES,
	TRANSACTION_TYPE_CODES,
	PAYER_FILTER_FIELDS,
	PAYER_STATUS_OPTIONS,
	PAYER_TRANSACTION_OPTIONS,
	PAYER_TABS,
	PAYER_ENROLLMENT_OPTIONS,
	DISABLE_PAYER_FIELDS,
};
